module.exports = __webpack_public_path__ + "img/5.879c625d.jpg";